import React from 'react';
import Chart from 'react-apexcharts';
export default function StackedBarChart(_ref) {
  let {
    series,
    categories,
    colors,
    height = 350,
    legendPosition = 'top'
  } = _ref;
  const chartMinWidth = categories.length > 0 ? "".concat(160 * categories.length, "px") : '';
  const options = {
    chart: {
      type: 'bar',
      stacked: true
    },
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          total: {
            enabled: true,
            style: {
              fontSize: '12px',
              fontWeight: 600,
              color: '#6b6b6b'
            },
            offsetY: -6
          }
        }
      }
    },
    xaxis: {
      categories
    },
    legend: {
      position: legendPosition
    },
    dataLabels: {
      enabled: true,
      // hide individual segment labels
      style: {
        colors: ['#6b6b6b']
      }
    },
    yaxis: {
      title: {
        text: 'Count'
      }
    },
    colors
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: chartMinWidth
    }
  }, /*#__PURE__*/React.createElement(Chart, {
    options: options,
    series: series,
    type: "bar",
    height: height
  }));
}